export const percentFromNumber = (total: number, portion: number): number =>
  (100 * portion) / total;
